import { Component } from '@angular/core';
import { ContactHeroSectionComponent } from "./components/contact-hero-section/contact-hero-section.component";
import { ContactContentSectionComponent } from "./components/contact-content-section/contact-content-section.component";
import { MapSectionComponent } from "./components/map-section/map-section.component";

@Component({
  selector: 'app-contact-us',
  imports: [ContactHeroSectionComponent, ContactContentSectionComponent, MapSectionComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css',
})
export class ContactUsComponent {

}
